<mat-icon [svgIcon]="silverCoin ? 'coin-silver' : (coinName | rewardCoinIcon)" class="big-coin"></mat-icon>
<span class="reward-cost" [class.disabled-text]="silverCoin">{{ rewardCost | numberAbbreviation }}</span>
